import styled from 'styled-components';
import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { ExlamationPoint, Typography } from '@dev/ee-components';
import useMobile from '@/services/hooks/useMobile';

interface StyledProps {
    marginTop?: number;
    marginBottom?: number;
}

const Notification = styled.div<StyledProps>`
    display: flex;
    margin-top: ${({ marginTop }): string => (marginTop ? `${marginTop}px` : '')};
    margin-bottom: ${({ marginBottom }): string => (marginBottom ? `${marginBottom}px` : '')};
`;
const Icon = styled.div`
    margin-right: 16px;
`;
const Content = styled.div`
    max-width: 600px;
    min-width: 100%;
`;

export const ActivateBillingDialogBody: FC = (): JSX.Element => {
    const isMobile = useMobile();
    const { t } = useTranslation('settings');
    return (
        <Content>
            <Grid container direction="column">
                <Grid item xs={12}>
                    <Notification marginTop={isMobile ? 8 : 20} marginBottom={isMobile ? 24 : 40}>
                        <Icon>
                            <ExlamationPoint color={'#5457fc'} />
                        </Icon>
                        <Typography variant="body1" bodyVariant="onPaper">
                            {t('activatebillingplaninfo')}
                        </Typography>
                    </Notification>
                </Grid>
            </Grid>
        </Content>
    );
};
